import React from "react";
import { useEffect, useState, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { gettransactionlist, addjournal, searchfolios,getaccountcharts,getfoliobalance,getviewreceiptdetails,searchtenantforreceipt,gettransactiondetailsbyaudit,addrentreceipt  } from "../../../../components/CommonSection/apiresources";
import { GetCookie } from "../../../../components/CommonSection/Cookie/Session";
import { makeRequestWithSpinner } from "../../../../Utilities/client";
import { useSpinnerContext } from "../../../../Utilities/SpinnerContext";
import "../../../../components/Dashboard/Dashboard-agent/AgentList.css";
import { ActionStatus } from "../../../../Utilities/enum";
import { addParametersForProfiles } from "../../../../Utilities/profileManagement";
import SubNav from "../../../navbar/subNav";
import AntdTableExample from "../../../input-components/dataTable";
import { Steps, DatePicker, message,Button, Dropdown, Table  } from 'antd';
import CustomModal from "../../../input-components/Modal";
import ShowValue from "../../../input-components/ShowValue";
import { format } from 'date-fns';
import SelectBox from "../../../input-components/selectBoxNew";
import TextBox from "../../../input-components/textbox";
import debounce from "lodash/debounce";
import { Select, Spin } from "antd";
import { useFormik } from "formik";
import moment from "moment";
import { HomeOutlined, UploadOutlined,BankOutlined,CreditCardOutlined,WarningOutlined } from '@ant-design/icons';
import ToastAlert from "../../../../components/CommonSection/ToastAlert/ToastAlert";
import NewTenantReceipt from "../newReceipt";

const initialValues = {
    date: "",
    accounts: "",
    details: "",
    taxInc: false,
    totalAmt: "",
    fromInv:"",
    supplier:""
};

const Transaction = () => {
    const [transactionsLists, setTransactionsLists] = useState([]);
    const [userId, setUserId] = useState("");
    const [agencyID, setAgencyId] = useState("");
    const navigate = useNavigate();
    const [searchText, setSearchText] = useState("");
    const [purpose, setPurpose] = useState(1);
    const { showSpinner, hideSpinner } = useSpinnerContext();
    const [rows, setRows] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [openAddProperty, setOpenAddProperty] = useState(false);
    const [getDetails, setGetDetails] = useState(null);
    const [addNew, setAddNew] = useState(false);
    const [view, setView] = useState(false);
    const [agentId, setAgentId] = useState("");
    const [folioBal, setFolioBal] = useState(null);
    const [accArr, setAccArr] = useState(10);
    const [auditNo, setAuditNo] = useState(0);

    const isTaxArr = [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
    ];
    const fromInvArr = [
        { value: 1, label: "Owner" },
        { value: 2, label: "Supplier" },
    ];
    const [viewTransactionDetails, setViewTransactionDetails] = useState(false);
    const inputRef = useRef();
    const [propertyimageitems, setPropertyimageitems] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [options, setOptions] = useState([]);
    const [searchValue, setSearchValues] = useState("");
    const [rowIds, setRowIds] = useState("");
    const fetchRef = useRef(0);
    const [supplierArr,setSupplierArr] = useState([]);
    const [fetchingSupplier, setFetchingSupplier] = useState(false);
    const [optionSupplier, setOptionSupplier] = useState([]);
    const [propertyId, setPropertyId] = useState("");
    const { Step } = Steps;
  const [takeMoneyFrom, setTakeMoneyFrom] = useState("");
    const [giveMoneyTo, setGiveMoneyTo] = useState("");
    const [ppenAddNewReceipt, setOpenAddNewReceipt] = useState(false);
    const [receiptDetails,setReceiptDetails]  = useState({});
    const [date, setDate] = useState(moment().format('YYYY-MM-DD'));
    const [selectedPaymentMode, setSelectedPaymentMode] = useState(4);
        const [rentData, setRentData] = useState([
            { allocation: "Rent", due: "21 Sep 2024", description: "Paid to 21/09/2024", amountDue: "13 days", amount: "" }
        ]);
        const [depositData, setDepositData] = useState([
            { description: "", amount: "" }
        ]);
    const ePaymentModes = [
        { value: 1, label: "Cash" },
        { value: 2, label: "Cheque" },
        { value: 3, label: "Card" },
        { value: 4, label: "EFT" }
    ];
    const [amount, setAmount] = useState(0);
    const [rentAmount,setRentAmount] = useState(null);
    const [invAmount,setinvAmount] = useState(null);
    const [invoiceAmounts, setInvoiceAmounts] = useState([]);
    const [supplierValue, setSupplierValues] = useState("");
    const [tenantValue, setTenantValues] = useState("");
    const ToastRef = useRef();


    useEffect(() => {
        const retrieveData = async () => {
            try {
                const userData = GetCookie("@UserData");
                if (userData) {
                    const parsedData = JSON.parse(userData);
                    setAgentId(parsedData.agentId)
                    setUserId(parsedData.userId);
                    setAgencyId(parsedData.agencyID);
                }
            } catch (error) {
                console.error("Error retrieving data from AsyncStorage:", error);
            }
        };
        retrieveData();
    }, [userId]);

    useEffect(() => {
        if (userId) getSupportList(1, 10);
    }, [userId, searchText, purpose]);


  useEffect(() => {
            getAccountList();
        }, [])

     const getAccountList = () => {
            const baseUrl = getaccountcharts + "?type=0";
            makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "get")
                .then((response) => {
                    if (response.status === ActionStatus.Successfull) {
                        const accArr = response.object.map(item => ({
                            label: item.text,
                            value: item.value
                        }));
                        setAccArr(accArr)
                    } else {
                        alert(`Message: ${response.message}`);
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        };

        const viewfoliobalance = (id) => {
            const baseUrl = getfoliobalance + `?Folio=${id}`;
            makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "get")
                .then((response) => {
                    if (response.status === ActionStatus.Successfull) {
                        setFolioBal(response.object)
                    } else {
                        alert(`Message: ${response.message}`);
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        };


    const getSupportList = (currentPage, totalRows) => {
        const baseUrl = gettransactionlist;
        let data = {
            AgencyId: agencyID,
            TabId: purpose,
            PageNo: currentPage,
        };

        data = addParametersForProfiles(data);
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    let transactionsData = response.list;
                    let transactionsList = transactionsData
                        .map((dis) => ({
                            auditNo: dis.auditNumer,
                            createdAt: moment(dis.createdAt).format("DD/MM/YYYY"),
                            reference: dis.reference,
                            Type: dis.sType,
                            propertyAddress: dis.propertyAddress,
                            summary: dis.summary,
                            amount: dis.amount ? '$' + ' ' + dis.amount : '-',
                            id: dis.propertyId,
                        }));
                    setTotalPages(response.totalCount)
                    setTransactionsLists(transactionsList);
                    setPropertyId("")
                } else {
                    message.error(response.message)
                    alert(`Message: ${response.message}`);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const {
        errors,
        values,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
        setValues,
        resetForm
    } = useFormik({
        initialValues: initialValues,
       // validationSchema: addNewUserOpenHome,
        onSubmit: (values, action) => {
            AddupdateInvoice()
        },
    });


    const AddupdateInvoice = () => {
        const baseUrl = addjournal;
        const data = {
            FolioTo: giveMoneyTo,
            FolioFrom: takeMoneyFrom,
            Details: values.details,
            AccountChart: parseInt(values.accounts),
            Amount: parseFloat(values.totalAmt),
            IsTaxable: values.taxInc,
            LoggedUserId: parseInt(userId),
            AgencyId: parseInt(agencyID),
        };
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    message.success(response.message)
                    getSupportList();
                    setOpenAddProperty(false);
                } else {
                    //ToastRef.current.notify(["error", "error"]);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    // Handler for page change
    const handlePageChange = (pageNumber, totalRows) => {
        setCurrentPage(pageNumber);
        setRows(totalRows);
        getSupportList(pageNumber, totalRows);
    };

    const tabColumns = {
        Status: {
            colorMap: {
                "Resolved": "#00A5A2",
                "Created": "#E5A000",
            },
            defaultColor: 'blue'
        }
    };

    const handleSearchValueChange = (value) => {
        setSearchText(value);
    };


    const actions = [
        { icon: "/assets/images/dots.svg",key:"View", onClick: (e, data) => handleView(e, data) },
        // { icon: "/assets/images/editing.svg", onClick: (e, data) => handleEdit(e, data) },
    ]

   
    const onSelectedRowKeysChange = (data, id) => {
        const selectedIds = id.map(row => row.id).join(',');
        setRowIds(selectedIds);
        setPropertyId(data)
    }

   
      
    const closeProperty = () => {
        const baseUrl = window.location.pathname;
        navigate(baseUrl);
        setOpenAddProperty(false);
        setView(false);
        setAddNew(false);
        setAmount("");
        setDepositData([{ description: "", amount: "" }]);
        setRentAmount("")
        setInvoiceAmounts([])
    }

    const openProperty = () => {
        setOpenAddProperty(true);
    }

    const items = [
        {
          key: '1',
          label: (
            <a >
              Folio Receipt
            </a>
          ),
        },
        {
          key: '2',
          label: (
            <a>
              Folio Withdraw
            </a>
          ),
        },
        {
          key: '3',
          label: (
            <a onClick={openProperty}>
             Journal
            </a>
          ),
        },
      ];  

                useEffect(() => {
                  agentUIDRef.current = agencyID;
                }, [agencyID]);
      
              const agentUIDRef = useRef(agencyID);

              const handleTakeMoneyFromChange = (value) => {
                setTakeMoneyFrom(value.value);
                setAuditNo(value.value)
            };
        
            // Function to handle "Give money to" selection
            const handleGiveMoneyToChange = (value) => {
                setGiveMoneyTo(value.value);
            };

       const debounceFetcher = useMemo(() => {
              const loadOptions = (value) => {
                const agentId = agentUIDRef.current;

                  fetchRef.current += 1;
                  const fetchId = fetchRef.current;
                  setOptions([]);
                  setFetching(true);
                  const baseUrl = searchfolios;
                  const data = {
                    Search: value,
                    AgencyId: agentId
                };
                  makeRequestWithSpinner(
                      showSpinner,
                      hideSpinner,
                      baseUrl,
                      "post",
                      data,
                      "",
                      false
                  )
                      .then((response) => {
                          if (response.status === 1) {
                              let landingPageListData = response.list;
      
                              // Transform data to match Select options
                              const transformedData = landingPageListData.map((item) => ({
                                  value: item.folio,
                                  label: item.folioReference + `(${item.folio})`,
                              }));
      
                              // Update options and fetching state
                              if (fetchId === fetchRef.current) {
                                  setOptions(transformedData);
                                  setFetching(false);
                              }
                          } else {
                              setFetching(false);
                          }
                      })
                      .catch((error) => {
                          setFetching(false);
                      });
              };
              return debounce(loadOptions, 800);
          }, []);
      
          const handleSearchProperty = (value) => {
              debounceFetcher(value);
              setSearchValues(value.value);
          };
      
          const handleClearProperty = () => {
              setFolioBal(null);
          };

           const viewreceiptdetails = (value) => {
                  const baseUrl = getviewreceiptdetails;
                  const apiUrl = `${baseUrl}?PropertyId=${value}`;
                  makeRequestWithSpinner(showSpinner, hideSpinner, apiUrl, "get")
                      .then((response) => {
                          if (response.status === ActionStatus.Successfull) {
                             setReceiptDetails(response.object)
                             setDepositData([
                                {
                                    description: `Deposit for ${response.object.propertyAddress}`,
                                    amount: ""
                                }
                            ]);
                          } else {
                              //handleparentsuccess(["warn", response.data.message]);
                          }
                      })
                      .catch((error) => {
                          //handleparentsuccess(["error", error]);
                      });
              };

          const handleStatClick = (selectedPurpose) => {
              setPurpose(selectedPurpose);
          };

          const handleOpenReceipt = () => {
                setOpenAddNewReceipt(true);
                //

        };
    
        const closeReceipt = () => {
            setOpenAddNewReceipt(false);
            setReceiptDetails({});
            setAmount(0);
            setRentAmount(null);
            setInvoiceAmounts([]);
            setDepositData([{ description: "", amount: "" }]);
            setSupplierValues("");
            setTenantValues("");
            setRentData([
                {
                    allocation: "Rent",
                    due: "",
                    description: "",
                    amountDue: "",
                    amount: ""
                }
            ]);
            setDate(moment().format('YYYY-MM-DD'));
        };
        

        const handleInputChange = (index, field, value, type, invId) => {
            const numericValue = parseFloat(value) || 0;
        
            if (type === "invoice") {
                setInvoiceAmounts((prevInvoices) => {
                    const updatedInvoices = [...prevInvoices];
                    const existingIndex = updatedInvoices.findIndex((item) => item.InvoiceId === invId);
        
                    if (existingIndex !== -1) {
                        updatedInvoices[existingIndex].Amount = numericValue;
                    } else {
                        updatedInvoices.push({ InvoiceId: invId, Amount: numericValue });
                    }
        
                    // After setting invoice data, calculate updated rent
                    recalculateRent(updatedInvoices, depositData);
                    return updatedInvoices;
                });
            }else if(type === "rent") {
                setRentAmount(numericValue);
                setDepositData([{ description: `Deposit for ${receiptDetails.propertyAddress}`, amount: "" }]);
                setInvoiceAmounts([])
            } else {
                const updatedDeposits = [...depositData];
                updatedDeposits[index][field] = numericValue;
                setDepositData(updatedDeposits);
        
                // After setting deposit data, calculate updated rent
                recalculateRent(invoiceAmounts, updatedDeposits);
            }
        };

        const handleReceiptSubmit = (formData) => {
            const payload = {
              Id: 0,
              Type: 1,
              Date: new Date().toISOString(),
              PaymentMode: selectedPaymentMode,
              Description: receiptDetails.propertyAddress,
              PropertyId: auditNo,
              AgencyId: agencyID,
              UserId: userId,
              ...formData,
            };
          
            makeRequestWithSpinner(showSpinner, hideSpinner, addrentreceipt, "post", payload)
              .then((res) => {
                if (res.status === 1) {
                  ToastRef.current.notify(["success", res.message]);
                  closeReceipt();
                } else {
                  ToastRef.current.notify(["error", res.message]);
                }
              })
              .catch(() => {
                ToastRef.current.notify(["error", "Something went wrong."]);
              });
          };
          
            
        const handleAmt = (e) => {
            const newAmt = parseFloat(e.target.value) || 0;
            setAmount(newAmt);
        
            const invoices = receiptDetails.invoiceDueList || [];
            const updatedInvoicePayments = [];
            let remaining = newAmt;
        
            // 1. Allocate to invoices first
            for (const invoice of invoices) {
                const due = parseFloat(invoice.amountDue || 0);
                const pay = Math.min(due, remaining);
        
                updatedInvoicePayments.push({ InvoiceId: invoice.id, Amount: pay });
                remaining -= pay;
        
                if (remaining <= 0) break;
            }
        
            // 2. Remaining goes to rent (partial or full)
            const rentToApply = remaining > 0 ? remaining : 0;
        
            // 3. Set all state values
            setInvoiceAmounts(updatedInvoicePayments);
            setRentAmount(rentToApply);
            setDepositData([
                { description: `Deposit for ${receiptDetails.propertyAddress}`, amount: "" }
            ]);
        };
        
            

            
                const debounceFetcherSupplier = useMemo(() => {
                    const loadOptions = (value) => {            
                        fetchRef.current += 1;
                        const fetchId = fetchRef.current;
                        setOptionSupplier([]);
                        setFetchingSupplier(true);
                        const baseUrl = searchtenantforreceipt ;
                        const data = {
                            Search: value,
                            RecordsPerPage:10,
                            PageNo:1
                        };
            
                        makeRequestWithSpinner(
                            showSpinner,
                            hideSpinner,
                            baseUrl,
                            "post",
                            data,
                            "",
                            false
                        )
                            .then((response) => {
                                if (response.status === 1) {
                                    let supplierListData = response.list;
                                    // Transform data to match Select options
                                    const transformedData = supplierListData.map((item) => ({
                                        label: item.name + `(${item.tenantAccountFolio})`,
                                        value: item.id,
                                    }));
            
                                    // Update options and fetching state
                                    if (fetchId === fetchRef.current) {
                                        setOptionSupplier(transformedData);
                                        setFetchingSupplier(false);
                                    }
                                } else {
                                    setFetchingSupplier(false);
                                }
                            })
                            .catch((error) => {
                                setFetchingSupplier(false);
                            });
                    };
                    return debounce(loadOptions, 800);
                }, []);
            
                const handleSearchSupplier = (value) => {
                    debounceFetcherSupplier(value);
                    setSupplierValues(value.value);
                    viewreceiptdetails(value.value);
                    setAuditNo(value.value)
                    setTenantValues(value.label)
                };
            
                const handleClearSupplier = () => {
                    setSupplierValues("");
                    setRentData([]);
                    setReceiptDetails([]);
                };

                const  viewTrasaction = (e,data) => {
                    setViewTransactionDetails(true);
                    GetDetailsApi(data.auditNo)
                }

                const closeViewTrasaction = () => {
                    setViewTransactionDetails(false)
                }
            
                const GetDetailsApi = (data) => {
                        const url = gettransactiondetailsbyaudit + `?AuditId=${data}`;
                        makeRequestWithSpinner(showSpinner, hideSpinner, url, "get", "", null, false)
                            .then((response) => {
                                if (response.status === ActionStatus.Successfull) {
                                    setGetDetails(response.object);
                                }
                            })
                            .catch((error) => {
                                console.error("Error fetching ticket details:", error);
                            })
                            .finally(() => {
                                //setLoading(false); // Set loading to false once API call completes
                            });
                    };

                    const handlefolio = (data,folio) => {
                        navigate(`/agency/accounts/folio?type=${data}&folio=${folio}`);
                        }

                        const handleProperty = (data) => {
                            navigate(`/agency/viewPropertyDetails?propertyUID=${data}`);
                        }

                    const columns = [
                        {
                          title: "Contact",
                          dataIndex: "contactName",
                          key: "contactName",
                          render: (text) => <span style={{ color: "#1890ff", cursor: "pointer" }}>{text}</span>,
                        },
                        {
                          title: "Folio",
                          dataIndex: "folio",
                          key: "folio",
                          render: (text) => <span onClick={()=> handlefolio("Tenant",text)} style={{ color: "#1890ff", cursor: "pointer" }}>{text}</span>,
                        },
                        {
                          title: "Chart Account",
                          dataIndex: "accountChart",
                          key: "accountChart",
                        },
                        {
                          title: "Detail",
                          dataIndex: "details",
                          key: "details",
                        },
                        {
                          title: "Tax",
                          dataIndex: "tax",
                          key: "tax",
                          render: (value) => (value ? "Yes" : "No"),
                        },
                        {
                          title: "Amount",
                          dataIndex: "amount",
                          key: "amount",
                          render: (amount) => `$${amount.toFixed(2)}`,
                        },
                      ];
                    
                      const getTotalAllocatedAmount = () => {
                        const invoiceTotal = invoiceAmounts.reduce((sum, inv) => sum + (parseFloat(inv.Amount) || 0), 0);
                        const depositTotal = depositData.reduce((sum, dep) => sum + (parseFloat(dep.amount) || 0), 0);
                        return (parseFloat(rentAmount) || 0) + invoiceTotal + depositTotal;
                    };

                    const recalculateRent = (invoices, deposits) => {
                        const totalInvoice = invoices.reduce((sum, inv) => sum + parseFloat(inv.Amount || 0), 0);
                        const totalDeposit = deposits.reduce((sum, dep) => sum + parseFloat(dep.amount || 0), 0);
                        const updatedRent = parseFloat(amount || 0) - totalInvoice - totalDeposit;
                    
                        setRentAmount(updatedRent < 0 ? 0 : updatedRent);
                    };

    return (
        <div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 changedateantdstyle">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 daily-date-style">
                    <SubNav title={"Transactions"} goback={false} extraData={true} />
                    <div className="material-work-desk-new bg-white m-3">
                    <ToastAlert ref={ToastRef} />

                        <div>
                           
                            <Button className="ml-2 mr-2 withdraw-btn" type="default" icon={<UploadOutlined />} >
                                Import Bank Files
                            </Button>
                            <Button onClick={handleOpenReceipt}  className="mr-2 withdraw-btn" type="default" icon={<HomeOutlined />} >
                                Add Tenant Receipt
                            </Button>
                            <Button  className="mr-2 withdraw-btn" type="default" icon={<BankOutlined />} >
                                Add Sale Receipt
                            </Button>
                            {/* <Button className="mr-2" type="default" icon={<CreditCardOutlined />} >
                                MePay
                            </Button> */}
                            <Dropdown
                                menu={{
                                    items,
                                }}
                                placement="bottom"
                                className="mr-2"
                            >
                                <Button className="mr-2 withdraw-btn">Other Action's</Button>
                            </Dropdown>
                            <Button className="mr-2 withdraw-btn" type="default" icon={<UploadOutlined />} >
                                Direct Debit
                            </Button>
                        </div>
                        <div className="mt-3">
                            <span className={`stat-items ${purpose === 1 ? 'active' : ''}`} onClick={() => handleStatClick(1)}>This Month</span>
                            <span className={`stat-items ${purpose === 2 ? 'active' : ''}`} onClick={() => handleStatClick(2)}>Last Month</span>
                            <span className={`stat-items ${purpose === 3 ? 'active' : ''}`} onClick={() => handleStatClick(3)}>All</span>
                        </div>
                        <AntdTableExample
                            showCheckbox
                            label="List Transactions"
                            dataSource={transactionsLists}
                            globalSearch
                            hideCol={"id"}
                            onPageChange={handlePageChange}
                            currentPage={currentPage}
                            totalRows={rows}
                            totalRecords={totalPages}
                            tagColumns={tabColumns}
                            onSearchValueChange={handleSearchValueChange}
                            actions={actions}
                            onSelectedRowKeysChange={onSelectedRowKeysChange}
                            onRowClick={viewTrasaction}
                        />
                    </div>
                    <CustomModal title={"Journal Transfer"} width={800} closable={closeProperty} visible={openAddProperty} onCancel={closeProperty}
                        modalData={
                            <div className="p-3" style={{marginTop:'-30px'}}>
                                <form onSubmit={handleSubmit} className="details-form" style={{ display: 'initial', width: '100%' }}>
                                    <div >
                                    <div className="row">
                                        <div className="col-12 col-lg-6 col-md-12 col-sm-12" >
                                            <label className='s1'>
                                                Take money from
                                            </label>
                                            <Select
                                                style={{ width: '100%', height: '40px' }}
                                                className="landingPageSearchs"
                                                mode="single"
                                                showSearch
                                                placeholder="Search for take money from"
                                                labelInValue
                                                filterOption={false}
                                                onSearch={debounceFetcher}
                                                notFoundContent={fetching ? <Spin size="small" /> : null}
                                                options={options}
                                                onChange={handleTakeMoneyFromChange}
                                                allowClear
                                                onClear={handleClearProperty}
                                            />
                                        </div>   
                                       
                                        <div className="col-12 col-lg-6 col-md-12 col-sm-12" >
                                            <label className='s1'>
                                            Give money to
                                            </label>
                                            <Select
                                                style={{ width: '100%', height: '40px' }}
                                                className="landingPageSearchs"
                                                mode="single"
                                                showSearch
                                                placeholder="Search for give money to"
                                                labelInValue
                                                filterOption={false}
                                                onSearch={debounceFetcher}
                                                notFoundContent={fetching ? <Spin size="small" /> : null}
                                                options={options}
                                                onChange={handleGiveMoneyToChange}
                                                allowClear
                                                onClear={handleClearProperty}
                                            />
                                        </div>  
                                        </div> 
                                        {folioBal ?
                                         <div>
                                           {folioBal.balance <= 0 ?
                                            <div style={{padding:'20px',background:'whitesmoke', borderRadius:'6px', width:'50%'}}>
                                                <span style={{fontWeight:'600',marginRight:'10px'}}><WarningOutlined style={{marginRight:'5px'}}/>Zero Balance</span><span>There are not funds in this folio.</span>
                                            </div> : null }
                                            <div className="contacts-group">
                                              <ShowValue Label="Balance" setData={folioBal.credit} />
                                              <ShowValue Label="Outstanding Bills" setData={folioBal.dues} />
                                              <ShowValue Label="Available Balance" setData={folioBal.balance} />
                                              </div>

                                        </div>: null }
                                        <div className="row">
                                        <TextBox value={values.details} name="details" label={"Details"} onChange={handleChange} onBlur={handleBlur} error={errors.details} touched={touched.details} />
                                        <SelectBox value={values.accounts} name="accounts" label={"Account"} options={accArr} onChange={(val) => setFieldValue("accounts", val.value)} onBlur={handleBlur} error={errors.accounts} touched={touched.accounts} />
                                        <SelectBox value={values.taxInc} name="taxInc" label={"Tax Inc"} options={isTaxArr} onChange={(val) => setFieldValue("taxInc", val.value)} onBlur={handleBlur} error={errors.taxInc} touched={touched.taxInc} />
                                        <TextBox value={values.totalAmt} name="totalAmt" label={"Amount"} onChange={handleChange} error={errors.totalAmt} onBlur={handleBlur} touched={touched.totalAmt} />
                                        </div>
                                    </div>
                                    <div className="property-details-buttons" style={{marginBottom:"-50px"}}>
                            <button className="pdb-cancel" type="reset"  onClick={closeProperty}>Cancel</button>
                            <button className="pdb-save-changes" type="submit">
                                Submit
                            </button>
                        </div>
                                </form>
                            </div>
                        }
                        footer={[]} 
                    />
                    <NewTenantReceipt
                        visible={ppenAddNewReceipt}
                        onClose={closeReceipt}
                        receiptDetails={receiptDetails}
                        supplierValue={supplierValue}
                        tenantValue={tenantValue}
                        ePaymentModes={ePaymentModes}
                        selectedPaymentMode={selectedPaymentMode}
                        setSelectedPaymentMode={setSelectedPaymentMode}
                        optionSupplier={optionSupplier}
                        fetchingSupplier={fetchingSupplier}
                        debounceFetcherSupplier={debounceFetcherSupplier}
                        handleSearchSupplier={handleSearchSupplier}
                        handleClearSupplier={handleClearSupplier}
                        onSubmit={handleReceiptSubmit}
                        ToastRef={ToastRef}
                        Tenant={true}
                    />


                    <CustomModal footer={null} title={ `${getDetails?.transactionType} #${getDetails?.referenceId} - ${getDetails?.paymentDescription}`} width={1000} closable={closeViewTrasaction} visible={viewTransactionDetails} onCancel={closeViewTrasaction}
                        modalData={
                            <div>
                                <div className="details-form p-3">
                                    <div className="contacts-group">
                                        <ShowValue Label='Created Date' setData={getDetails?.createdAt ? format(new Date(getDetails.createdAt), 'dd/MM/yyyy hh:mm') : "N/A"} />
                                        <ShowValue Label='Paid By' setData={getDetails?.paidBy} />
                                        <ShowValue Label='Transaction Date' setData={getDetails?.transactionDate ? format(new Date(getDetails.transactionDate), 'dd/MM/yyyy hh:mm') : "N/A"} />
                                        <ShowValue Label='Property' setData={getDetails?.propertyAddress ? getDetails?.propertyAddress : "N/A"} onClick={() => handleProperty(getDetails?.propertyUId)} link={true} />
                                        <ShowValue Label='Processed By' setData={getDetails?.processedBy} />

                                        <h6 style={{ marginTop: "20px" }}>Transaction Details</h6>
                                        <Table columns={columns} dataSource={getDetails?.transactionsDetails} pagination={false} />

                                        <div style={{ textAlign: "right", marginTop: "10px", fontSize: "16px", fontWeight: "bold" }}>
                                            Total: ${getDetails?.totalAmount ? getDetails.totalAmount.toFixed(2) : "0.00"}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                    />
                </div>
            </div>
        </div>
    );
};

export default Transaction;
